// Track online/offline state + periodic health check against the backend.
import { useEffect, useState, useCallback } from "react";
import { api } from "@/api/client";

export function useNetworkStatus(pingIntervalMs = 30000) {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [backendOk, setBackendOk] = useState(true);
  const [lastCheck, setLastCheck] = useState(null);

  const ping = useCallback(async () => {
    try {
      const r = await api.get("/health", { timeout: 5000 });
      setBackendOk(r?.data?.status === "ok");
      setLastCheck(new Date());
    } catch {
      setBackendOk(false);
      setLastCheck(new Date());
    }
  }, []);

  useEffect(() => {
    const onOnline = () => { setOnline(true); ping(); };
    const onOffline = () => { setOnline(false); setBackendOk(false); };
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    ping();
    const iv = setInterval(ping, pingIntervalMs);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
      clearInterval(iv);
    };
  }, [ping, pingIntervalMs]);

  return { online, backendOk, lastCheck, refresh: ping };
}
